import React from 'react';
import { Link } from 'react-router-dom';
import './BrowseByDepartment.css';
import useDepartments from '../../hooks/useDepartments';

const BrowseByDepartment = () => {
  const { departments, loading, error } = useDepartments();

  if (loading) {
    return (
      <div className="browse-by-department">
        <div className="bbd-header">
          <h2>Browse Courses by Department</h2>
          <Link to="/departments" className="view-all-link">View all departments →</Link>
        </div>
        <div className="bbd-grid">
          <div className="loading-message">Loading departments...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="browse-by-department">
        <div className="bbd-header">
          <h2>Browse Courses by Department</h2>
          <Link to="/departments" className="view-all-link">View all departments →</Link>
        </div>
        <div className="bbd-grid">
          <div className="error-message">Error loading departments: {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="browse-by-department">
      <div className="bbd-header">
        <h2>Browse Courses by Department</h2>
        <Link to="/departments" className="view-all-link">View all departments →</Link>
      </div>
      <div className="bbd-grid">
        {departments.map(dept => (
          <Link to={`/departments/${dept.name}`} key={dept.id} className="bbd-card-link">
            <div className="bbd-card">
              <div className="bbd-image-container">
                <img src={dept.image} alt={dept.name} className="bbd-department-image" />
              </div>
              <h3>{dept.name}</h3>
              <p>{dept.description}</p>
              <span>{dept.courses} courses</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BrowseByDepartment;
